<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        แก้ไขผู้ดูแลระบบ
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> จัดการผู้ดูแลระบบ
          </a>
        </li>
        <li class="active">แก้ไขผู้ดูแลระบบ</li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-xs-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">ข้อมูลทั่วไป</h3>
            </div>
            <div class="box-body">
              <el-form
                size="mini"
                :label-position="label_position"
                label-width="150px"
                :model="userdata"
              >
                <div class="row">
                  <div class="col-xs-12">
                    <el-form-item label="ชื่อ" required>
                      <el-input clearable v-model="userdata.first_name" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="นามสกุล" required>
                      <el-input clearable v-model="userdata.last_name" maxlength='50'></el-input>
                    </el-form-item>
                    <el-form-item label="เบอร์โทรศัพท์">
                      <el-input clearable v-model="userdata.phone_number" @keypress.native="isNumberKey"  show-word-limit maxlength="10"></el-input>
                    </el-form-item>
                    <el-form-item label="อีเมล (E-mail)" required>
                      <el-input v-model="userdata.email" @keypress.native="checkCharater" maxlength="50"></el-input>
                    </el-form-item>
                    <el-form-item label="หน่วยงาน" required>
                      <el-input clearable v-model="userdata.departments" maxlength="100"></el-input>
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
          </div>
        </div>
        <!-- /////////////////////// -->
        <div class="col-xs-6">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">เปลี่ยนรูปโปรไฟล์</h3>
            </div>
            <div class="box-body" align="center">
              <div id="preview" style="height: 348px">
                <template v-if="userdata.profile_img">
                  <img v-if="userdata.profile_img" :src="this.avatar" />
                </template>
              </div>
              <br />
              <el-upload
                type="file"
                class="upload-demo"
                ref="file"
                action="#"
                :on-change="onFileChange"
                :show-file-list="false"
                :limit="1"
                :auto-upload="false"
                accept="image/jpeg,image/png"
              >
              <el-button
                slot="trigger"
                size="small"
                type="primary"
              >เลือกรูปภาพ</el-button>
              </el-upload>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-xs-12">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title" style="float: left">สิทธิการจัดการ</h3>
              <h3 class="box-title" style="float: right">
                <el-checkbox label="เลือกทั้งหมด" @change="pickAll"></el-checkbox>
              </h3>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-xs-12">
                  <data-tables
                    :data="manage_menu"
                    :page-size="5"
                    :pagination-props="{ background: true, pageSizes: [5, 10] }"
                    >
                    <el-table-column prop="menu_name" label="ชื่อเมนู" width="650"></el-table-column>
                    <el-table-column width label="สิทธิการจัดการ">
                      <template slot-scope="scope">
                        <div v-if="scope.row.menu == 'Manage_user'">
                          <el-checkbox-group v-model="form_permission.Manage_user">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ใช้งาน</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ใช้งาน</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_admin'">
                          <el-checkbox-group v-model="form_permission.Manage_admin">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มผู้ดูแลระบบ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ดูแลระบบ</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ดูแลระบบ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_operator'">
                          <el-checkbox-group v-model="form_permission.Manage_operator">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มผู้ให้บริการ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขผู้ให้บริการ</el-checkbox>
                            <el-checkbox label="delete">ลบผู้ให้บริการ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Typegroup'">
                          <el-checkbox-group v-model="form_permission.Typegroup">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มกลุ่มบริษัท</el-checkbox>
                            <el-checkbox label="edit">แก้ไขกลุ่มบริษัท</el-checkbox>
                            <el-checkbox label="delete">ลบกลุ่มบริษัท</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'ListOperator'">
                          <el-checkbox-group v-model="form_permission.ListOperator">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_average'">
                          <el-checkbox-group v-model="form_permission.Manage_averagetosave">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_service'">
                          <el-checkbox-group v-model="form_permission.Manage_service">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_terms_and_condition'">
                          <el-checkbox-group v-model="form_permission.Manage_terms_and_condition">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_privacy_data_policy'">
                          <el-checkbox-group v-model="form_permission.Manage_privacy_data_policy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_security_policy'">
                          <el-checkbox-group v-model="form_permission.Manage_security_policy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_cookie_privacy'">
                          <el-checkbox-group v-model="form_permission.Manage_cookie_privacy">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_question'">
                          <el-checkbox-group v-model="form_permission.Manage_question">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูล</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_article'">
                          <el-checkbox-group v-model="form_permission.Manage_article">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูลบทความ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูลบทความ</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูลบทความ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_news'">
                          <el-checkbox-group v-model="form_permission.Manage_news">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="add">เพิ่มข้อมูลบทความ</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูลบทความ</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูลบทความ</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_banner'">
                          <el-checkbox-group v-model="form_permission.Manage_banner">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขรูปภาพโฆษณา</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_mobile'">
                          <el-checkbox-group v-model="form_permission.Manage_mobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_internet'">
                          <el-checkbox-group v-model="form_permission.Manage_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_request_mobile'">
                          <el-checkbox-group v-model="form_permission.Manage_request_mobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_request_internet'">
                          <el-checkbox-group v-model="form_permission.Manage_request_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_data'">
                          <el-checkbox-group v-model="form_permission.Manage_data">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Upload_save'">
                          <el-checkbox-group v-model="form_permission.Upload_save">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="delete">ลบข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_promotion_mobile_type'">
                          <el-checkbox-group
                            v-model="form_permission.Report_promotion_mobile_type"
                          >
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_rate'">
                          <el-checkbox-group v-model="form_permission.Services_rate">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Program_technologies'">
                          <el-checkbox-group v-model="form_permission.Program_technologies">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_change'">
                          <el-checkbox-group v-model="form_permission.Services_change">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Pro_seconds_G5'">
                          <el-checkbox-group v-model="form_permission.Pro_seconds_G5">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Promotion_table_avg'">
                          <el-checkbox-group v-model="form_permission.Promotion_table_avg">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Promotion_percent'">
                          <el-checkbox-group v-model="form_permission.Promotion_percent">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_trends'">
                          <el-checkbox-group v-model="form_permission.Services_trends">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G9'">
                          <el-checkbox-group v-model="form_permission.Fast_internet_home_G9">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Services_internet'">
                          <el-checkbox-group v-model="form_permission.Services_internet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G11'">
                          <el-checkbox-group v-model="form_permission.Fast_internet_home_G11">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Fast_internet_home_G12'">
                          <el-checkbox-group v-model="form_permission.Fast_internet_home_G12">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Reportview_promotion'">
                          <el-checkbox-group v-model="form_permission.Reportview_promotion">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_blockchain'">
                          <el-checkbox-group v-model="form_permission.Report_blockchain">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Manage_mobile_service'">
                          <el-checkbox-group v-model="form_permission.Manage_mobile_service">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                            <el-checkbox label="edit">แก้ไขข้อมูล</el-checkbox>
                          </el-checkbox-group>
                        </div>
                           <div v-if="scope.row.menu == 'Popular_proMobile'">
                          <el-checkbox-group v-model="form_permission.Popular_proMobile">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                           <div v-if="scope.row.menu == 'Popular_proInternet'">
                          <el-checkbox-group v-model="form_permission.Popular_proInternet">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Access_log'">
                          <el-checkbox-group v-model="form_permission.Access_log">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Report_promotion_ranking'">
                          <el-checkbox-group v-model="form_permission.Report_promotion_ranking">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'User_behavior'">
                          <el-checkbox-group v-model="form_permission.User_behavior">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                        <div v-if="scope.row.menu == 'Uteleme'">
                          <el-checkbox-group v-model="form_permission.Uteleme">
                            <el-checkbox label="true">อนุญาต</el-checkbox>
                          </el-checkbox-group>
                        </div>
                      </template>
                    </el-table-column>
                  </data-tables>
                  <div class="box-footer">
                    <el-button style="float: left" type="secondary" @click="back()">ยกเลิก</el-button>
                    <el-button style="float: right" type="primary" @click="submitForm()">บันทึก</el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      file: null,
      avatar: null,
      checkList: "",
      label_position: "top",
      form_permission: {}
    };
  },
  mounted() {
    if(!this.userdata.role_permission) this.$router.push({name : 'Manage_admin'})
    this.avatar = this.config().API_URL+this.userdata.profile_img
    this.form_permission = this.userdata.role_permission
    console.log(this.userdata.role_permission)
  },
  computed: {
    ...mapState({
      manage_menu: store => store.Menu.manage_menu,
      userdata : store => store.Manage_admin.edit_data,
      permission_add : store => store.Manage_admin.permission_add,
      permission_edit : store => store.Manage_admin.permission_edit,
      permission_delete : store => store.Manage_admin.permission_delete,
    })
  },
  methods: {
    ...mapActions({
      update_admin : "Manage_admin/update_admin"
    }),
    checkEmail(email) {
      return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
    },
    submitForm() {
      if (this.userdata.first_name.length < 4) {
        this.$confirm("กรุณากรอกชื่อ ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      } else if (this.userdata.last_name.length < 4) {
        this.$confirm("กรุณากรอกนามสกุล ความยาว 4 - 50 ตัวอักษร", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      } else if (!this.userdata.email) {
        this.$confirm("กรุณากรอกอีเมลผู้ดูแลระบบ", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      } else if (!this.checkEmail(this.userdata.email)) {
        this.$confirm("รูปแบบอีเมลไม่ถูกต้อง", "แจ้งเตือน", {
          confirmButtonText: "ตกลง",
          showCancelButton: false,
          type: "warning"
        })
      } else {
        let formdata = new FormData()
        if(this.file){
          formdata.append("typeFile", "profile")
          formdata.append("file", this.file)
        }
        formdata.append('role_permission', JSON.stringify(this.form_permission))
        this.update_admin(formdata)
      }
    },
    onFileChange(e,list) {
      this.$refs.file.clearFiles()
      this.file = e.raw;
      this.avatar = URL.createObjectURL(this.file);
    },
    back(){
      this.$router.push({name : 'Manage_admin'})
    },
    pickAll(check){
      this.form_permission = {
        Manage_user: ["Manage_user"],
        Manage_admin: ["Manage_admin"],
        Manage_operator: ["Manage_operator"],
        Typegroup: ["Typegroup"],
        ListOperator: ["ListOperator"],
        Manage_averagetosave: ["Manage_averagetosave"],
        Promotion_table_avg: ["Promotion_table_avg"],
        Manage_service: ["Manage_service"],
        Manage_question: ["Manage_question"],
        Manage_article: ["Manage_article"],
        Manage_news: ["Manage_news"],
        Manage_mobile: ["Manage_mobile"],
        Manage_internet: ["Manage_internet"],
        Manage_request_mobile: ["Manage_request_mobile"],
        Manage_request_internet: ["Manage_request_internet"],
        Manage_data: ["Manage_data"],
        Upload_save: ["Upload_save"],
        Report_promotion_mobile_type: ["Report_promotion_mobile_type"],
        Services_rate: ["Services_rate"],
        Program_technologies: ["Program_technologies"],
        Services_change: ["Services_change"],
        Pro_seconds_G5: ["Pro_seconds_G5"],
        Promotion_percent: ["Promotion_percent"],
        Services_trends: ["Services_trends"],
        Fast_internet_home_G9: ["Fast_internet_home_G9"],
        Services_internet: ["Services_internet"],
        Report_blockchain: ["Report_blockchain"],
        Fast_internet_home_G11: ["Fast_internet_home_G11"],
        Fast_internet_home_G12: ["Fast_internet_home_G12"],
        Reportview_promotion: ["Reportview_promotion"],
        Manage_mobile_service : ['Manage_mobile_service'],
        Popular_proMobile:['Popular_proMobile'],
        Popular_proInternet:['Popular_proInternet'],
        Access_log: ['Access_log'],
        Report_promotion_ranking : ['Report_promotion_ranking'],
        User_behavior: ['User_behavior'],
        Manage_terms_and_condition: ['Manage_terms_and_condition'],
        Manage_privacy_data_policy: ['Manage_privacy_data_policy'],
        Manage_security_policy: ['Manage_security_policy'],
        Manage_cookie_privacy: ['Manage_cookie_privacy'],
        Uteleme: ['Uteleme'],
        Manage_banner: ['Manage_banner']
      }
      if(check){
        for(let col in this.form_permission){
          this.form_permission[col].push('true')
        }
        for(let col of this.permission_add){
          this.form_permission[col].push('add')
        }
        for(let col of this.permission_edit){
          this.form_permission[col].push('edit')
        }
        for(let col of this.permission_delete){
          this.form_permission[col].push('delete')
        }
      }
    }
  }
};
</script>
